import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './interceptors/auth.guard';

const routes: Routes = [

 {
    path: '',
    redirectTo: 'purchase-orders',
    pathMatch: 'full'
  },
  {
    path: 'purchase-orders',
    //canActivate: [AuthGuard],
    loadChildren: () => import("./purchase-orders/purchase-orders.module").then(m => m.PurchaseOrdersModule)
  },
  {
    path: 'purchase-order',
    //canActivate: [AuthGuard],
    loadChildren: () => import("./purchase-order/purchase-order.module").then(m => m.PurchaseOrderModule)
  }
  
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {enableTracing:true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
